<template>
  <div>
    <modal id="editBotClient"
           :show="showModal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="close">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('botClients.edit.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('botClients.edit.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('botClients.details.name') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'name'"
                name="id"
                v-validate="modelValidations.required"
                :error="getError('name')"
                v-model="formDetails.name">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.status') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="role"
                v-model="formDetails.status"
              >
                <el-option
                  v-for="option in availableStatuses"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('botClients.details.cidrs') }}</label>
            <div class="col">
              <div class="form-group">
                <tags-input v-model="formDetails.cidrs"
                            :input-placeholder="$t('botClients.form.cidrPlaceholder')"
                            input-size="" tag-size="medium"></tags-input>
              </div>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('botClients.edit.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import TagsInput from "src/components/Inputs/TagsInput.vue";
import swal from "sweetalert2";

export default {
  name: 'new-bot-client-btn',
  props: {
    formDetails: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
  },
  components: {
    TagsInput,
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      modelValidations: {
        required: {
          required: true
        },
      },
      availableStatuses: ['active', 'suspended'],
    }
  },

  computed: {
    ...mapState({
      details: state => state.municipality_bot_client.data,
      updating: state => state.municipality_bot_client.updating,
      error: state => state.municipality_bot_client.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error : null;
    },
    showModal() {
      return this.show == true
    }
  },
  methods: {
    ...mapActions(['UpdateBotClient']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    close: function () {
      this.$emit('close');
    },
    create: function () {
      let payload = {
        id: this.formDetails.id,
        data: {
          status: this.formDetails.status,
          name: this.formDetails.name,
          cidrs: this.formDetails.cidrs,
        }
      }

      this.UpdateBotClient(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('botClients.edit.createdNotification', payload.data),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.close();
        }
      });
    },
  }
}
</script>
